import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getCookie } from 'utils/cookie.helper';
import { TApi } from 'utils/api';
import {
  SEARCH_CONFIGURATIONS_DEFAULT_PAGE,
  SEARCH_CONFIGURATIONS_DEFAULT_SIZE,
  CUSTOMER_ID_COOKIE_NAME,
  UNAUTHORIZED_CUSTOMER_ID_COOKIE_NAME,
  SEARCH_CONFIGURATIONS_ENDPOINT,
} from '../const';
import { roomsAtom } from '../store/rooms';
import { TSearchConfigurationsResponse } from '../types';
import { getSearchConfigurationsBody } from '../helpers/get-search-configurations-body';
import { parseSearchConfigurationsResponse } from '../helpers/parse-search-configurations-response';
import { clearRoomsStorage } from '../helpers/clear-rooms-storage';

type TParams = {
  apiMethods: TApi;
  isFloor: boolean;
  calculatorId?: string;
};

export const useSearchRooms = ({ apiMethods, isFloor, calculatorId }: TParams) => {
  const calculatedRooms = useRecoilValue(roomsAtom);
  const setRoomsState = useSetRecoilState(roomsAtom);

  useEffect(() => {
    clearRoomsStorage();
    const authorizedCustomerId = getCookie(CUSTOMER_ID_COOKIE_NAME);
    const unauthorizedCustomerId = getCookie(UNAUTHORIZED_CUSTOMER_ID_COOKIE_NAME);
    const isAnyCustomerIdExists = Boolean(authorizedCustomerId) || Boolean(unauthorizedCustomerId);
    async function getRooms() {
      const body = getSearchConfigurationsBody(authorizedCustomerId, unauthorizedCustomerId);
      try {
        const configurations: TSearchConfigurationsResponse = await apiMethods.post(
          `${SEARCH_CONFIGURATIONS_ENDPOINT}?page=${SEARCH_CONFIGURATIONS_DEFAULT_PAGE}&size=${SEARCH_CONFIGURATIONS_DEFAULT_SIZE}`,
          body
        );
        const rooms = parseSearchConfigurationsResponse(configurations, calculatorId);
        setRoomsState(rooms);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('get rooms failed', e);
      }
    }

    if (isFloor && calculatedRooms.length === 0 && isAnyCustomerIdExists) {
      getRooms();
    }
  }, [apiMethods, calculatedRooms.length, calculatorId, isFloor, setRoomsState]);
};
